//# sourceMappingURL=document_context.mjs.map
/// <reference types="./document_context.d.mts" />
import * as $json from "../../../gleam_json/gleam/json.mjs";
import * as $decode from "../../../gleam_stdlib/gleam/dynamic/decode.mjs";
import * as $int from "../../../gleam_stdlib/gleam/int.mjs";
import * as $option from "../../../gleam_stdlib/gleam/option.mjs";
import { None, Some } from "../../../gleam_stdlib/gleam/option.mjs";
import * as $result from "../../../gleam_stdlib/gleam/result.mjs";
import * as $a from "../../../redraw_dom/redraw/dom/attribute.mjs";
import * as $html_parser from "../../common/html_parser.mjs";
import { Ok, toList, CustomType as $CustomType } from "../../gleam.mjs";

export class FromDocx extends $CustomType {}
export const Origin$FromDocx = () => new FromDocx();
export const Origin$isFromDocx = (value) => value instanceof FromDocx;

export class FromEditor extends $CustomType {}
export const Origin$FromEditor = () => new FromEditor();
export const Origin$isFromEditor = (value) => value instanceof FromEditor;

export class DocumentContext extends $CustomType {
  constructor(id, index, origin, original_index, segment_index) {
    super();
    this.id = id;
    this.index = index;
    this.origin = origin;
    this.original_index = original_index;
    this.segment_index = segment_index;
  }
}
export const DocumentContext$DocumentContext = (id, index, origin, original_index, segment_index) =>
  new DocumentContext(id, index, origin, original_index, segment_index);
export const DocumentContext$isDocumentContext = (value) =>
  value instanceof DocumentContext;
export const DocumentContext$DocumentContext$id = (value) => value.id;
export const DocumentContext$DocumentContext$0 = (value) => value.id;
export const DocumentContext$DocumentContext$index = (value) => value.index;
export const DocumentContext$DocumentContext$1 = (value) => value.index;
export const DocumentContext$DocumentContext$origin = (value) => value.origin;
export const DocumentContext$DocumentContext$2 = (value) => value.origin;
export const DocumentContext$DocumentContext$original_index = (value) =>
  value.original_index;
export const DocumentContext$DocumentContext$3 = (value) =>
  value.original_index;
export const DocumentContext$DocumentContext$segment_index = (value) =>
  value.segment_index;
export const DocumentContext$DocumentContext$4 = (value) => value.segment_index;

function origin_decoder() {
  return $decode.then$(
    $decode.string,
    (string) => {
      if (string === "docx") {
        return $decode.success(new FromDocx());
      } else if (string === "editor") {
        return $decode.success(new FromEditor());
      } else {
        return $decode.failure(new FromDocx(), "origin");
      }
    },
  );
}

export function decoder() {
  return $decode.field(
    "id",
    $decode.string,
    (id) => {
      return $decode.field(
        "index",
        $decode.int,
        (index) => {
          return $decode.field(
            "origin",
            origin_decoder(),
            (origin) => {
              return $decode.field(
                "original_index",
                $decode.optional($decode.int),
                (original_index) => {
                  return $decode.field(
                    "segment_index",
                    $decode.optional($decode.int),
                    (segment_index) => {
                      return $decode.success(
                        new DocumentContext(
                          id,
                          index,
                          origin,
                          original_index,
                          segment_index,
                        ),
                      );
                    },
                  );
                },
              );
            },
          );
        },
      );
    },
  );
}

function encode_origin(origin) {
  if (origin instanceof FromDocx) {
    return $json.string("docx");
  } else {
    return $json.string("editor");
  }
}

export function encode(context) {
  return $json.object(
    toList([
      ["id", $json.string(context.id)],
      ["index", $json.int(context.index)],
      ["origin", encode_origin(context.origin)],
      ["original_index", $json.nullable(context.original_index, $json.int)],
      ["segment_index", $json.nullable(context.segment_index, $json.int)],
    ]),
  );
}

export function to_html_attributes(context) {
  let id_attr = $a.attribute("data-id", context.id);
  let index_attr = $a.attribute("data-index", $int.to_string(context.index));
  let _block;
  let $ = context.origin;
  if ($ instanceof FromDocx) {
    _block = "docx";
  } else {
    _block = "editor";
  }
  let origin_str = _block;
  let origin_attr = $a.attribute("data-origin", origin_str);
  let _block$1;
  let $1 = context.original_index;
  if ($1 instanceof Some) {
    let idx = $1[0];
    _block$1 = $a.attribute("data-original-index", $int.to_string(idx));
  } else {
    _block$1 = $a.none();
  }
  let original_index_attr = _block$1;
  let _block$2;
  let $2 = context.segment_index;
  if ($2 instanceof Some) {
    let idx = $2[0];
    _block$2 = $int.to_string(idx);
  } else {
    _block$2 = "none";
  }
  let segment_index_str = _block$2;
  let segment_index_attr = $a.attribute("data-segment-index", segment_index_str);
  return toList([
    id_attr,
    index_attr,
    origin_attr,
    original_index_attr,
    segment_index_attr,
  ]);
}

export function from_html_attributes(element) {
  let _block;
  let _pipe = $html_parser.extract_attribute("data-id", element);
  let _pipe$1 = $option.from_result(_pipe);
  _block = $option.unwrap(_pipe$1, "");
  let id = _block;
  let _block$1;
  let _pipe$2 = $html_parser.extract_attribute("data-index", element);
  let _pipe$3 = $result.try$(_pipe$2, $int.parse);
  _block$1 = $result.unwrap(_pipe$3, 0);
  let index = _block$1;
  let _block$2;
  let $ = $html_parser.extract_attribute("data-origin", element);
  if ($ instanceof Ok) {
    let $1 = $[0];
    if ($1 === "docx") {
      _block$2 = new FromDocx();
    } else {
      _block$2 = new FromEditor();
    }
  } else {
    _block$2 = new FromEditor();
  }
  let origin = _block$2;
  let _block$3;
  let _pipe$4 = $html_parser.extract_attribute("data-original-index", element);
  let _pipe$5 = $result.try$(_pipe$4, $int.parse);
  _block$3 = $option.from_result(_pipe$5);
  let original_index = _block$3;
  let _block$4;
  let $1 = $html_parser.extract_attribute("data-segment-index", element);
  if ($1 instanceof Ok) {
    let $2 = $1[0];
    if ($2 === "none") {
      _block$4 = new $option.None();
    } else {
      let str = $2;
      let _pipe$6 = $int.parse(str);
      _block$4 = $option.from_result(_pipe$6);
    }
  } else {
    _block$4 = new $option.None();
  }
  let segment_index = _block$4;
  return new DocumentContext(id, index, origin, original_index, segment_index);
}

export function empty() {
  return new DocumentContext("", -1, new FromEditor(), new None(), new None());
}
